<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Framen" id="_idContainer001">
<p class="ebook-toc" id="_idParaDest-1"><span class="ch-opener CharOverride-1"><a id="_idTextAnchor000"></a>also by najwa zebian</span></p>
<p class="Normal ParaOverride-1"><span class="poem-itals CharOverride-2">Mind Platter</span></p>
<p class="Normal ParaOverride-1"><span class="poem-itals CharOverride-2">The Nectar of Pain</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SparksPhoenix_epub1.vue?02b2fdad